import { CostAllocationRefersTo } from 'types';
import { settlementTexts } from 'consts/text';

export const referToMapper = {
    [CostAllocationRefersTo.STAY]: settlementTexts.children.costAllocation.stay,
    [CostAllocationRefersTo.MEAL]: settlementTexts.children.costAllocation.meals,
    [CostAllocationRefersTo.EXTRA_LESSONS]: settlementTexts.children.costAllocation.extraLessons,
    [CostAllocationRefersTo.OTHER]: settlementTexts.children.costAllocation.other,
};
